// Auth main object
export const authenticationService = {
  isAuthenticated: false,
  login,
  logout,
  signup,
  validateUser,
  passwordRecovery,
  checkExistence,
  getCurrentUser,
  getBaseURL,
  currentUser: JSON.parse(localStorage.getItem('currentUser')),
  fetchApi,
  fetchPublic
};
function fetchApi(params){
  // console.log(1);
  // console.log(params);
  let headers = {
    'Authorization': 'Token ' + authenticationService.currentUser.token
  }
  if('ContentType' in params){
    if(params['ContentType'] ===  'multipart'){
      headers['Content-Type'] = 'multipart/form-data';
    }
    else if(params['ContentType'] ===  'xlsx'){
      // headers['Content-Type'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      headers['Accept'] = 'application/xlsx';
    }
    else{
      headers['Content-Type'] = 'application/json';
    }
  }
  else{
    headers['Content-Type'] = 'application/json';
  }
  const options = {
    method: params.method,
    headers: headers,
    ...params.body && { body: params.body },
  };
  // console.log(options);

  return new Promise( (resolve, reject) =>
    fetch(authenticationService.getBaseURL().server_url + params.url, options)
    .then(res => {
      let status = res.status;
      let statusText = res.statusText;
      // console.log(res);
      if([200,201,202,203,204,205,206,207,208,226].includes(status)){
        if ('ContentType' in params) {
          if(params['ContentType'] !== 'json'){
            return resolve(res);
          }
        }
        else if (status === 204) {
          return resolve(res);
        }

        return resolve(res.json());
      }
      else if([401].includes(status)){
        window.location.replace("/login");
      }

      else{
        let error = {
          error: true,
          status: status,
          statusText:  statusText,
          description: 'Something else'
        }

        if('no_error_popup' in params){
          // NO DIALOG FOR ERROR
        }
        else{
          localStorage.setItem('error',JSON.stringify(error));
          window.dispatchEvent( new Event('storage') )
        }
        // return reject(res.json());
        res.json().then(json => {
          return reject(json);
        })

      }
    })
    .catch(err => {
      console.log('ERROR', err);
    })

  );
}

function fetchPublic(params){
  // console.log(1);
  // console.log(params);
  let headers = {}
  if('ContentType' in params){
    if(params['ContentType'] ===  'multipart'){
      headers['Content-Type'] = 'multipart/form-data';
    }
    else if(params['ContentType'] ===  'xlsx'){
      headers['Content-Type'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
    else{
      headers['Content-Type'] = 'application/json';
    }
  }
  else{
    headers['Content-Type'] = 'application/json';
  }
  if('captcha' in params){
    headers['X-CSRFToken'] = params.captcha
  }
  const options = {
    method: params.method,
    headers: headers,
    ...params.body && { body: params.body },
  };
  // console.log(options);

  return new Promise( (resolve, reject) =>
    fetch(authenticationService.getBaseURL().server_url + params.url, options)
    .then(res => {
      let status = res.status;
      let statusText = res.statusText;
      // console.log(res);
      if([200,201,202,203,204,205,206,207,208,226].includes(status)){
        if ('ContentType' in params) {
          if(params['ContentType'] !== 'json'){
            return resolve(res);
          }
        }
        else if (status === 204) {
          return resolve(res);
        }

        return resolve(res.json());
      }
      else if([401].includes(status)){
        window.location.replace("/");
      }

      else{
        // return resolve(res.json());
        let error = {
          error: true,
          status: status,
          statusText:  statusText,
          description: 'Something else'
        }
        console.log(params)
        if('no_error_popup' in params){
          // NO DIALOG FOR ERROR
        }
        else{
          localStorage.setItem('error',JSON.stringify(error));
          window.dispatchEvent( new Event('storage') )
        }
        // return reject(res.json());
        res.json().then(json => {
          return reject(json);
        })

      }
    })
    .catch(err => {
      console.log('ERROR', err);
    })

  );
}



function getCurrentUser(){
  authenticationService.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if(authenticationService.currentUser){authenticationService.isAuthenticated=true;}
  return authenticationService.currentUser;
}

function login(data){
  // console.log('entra a Login');
  return(

    fetch( authenticationService.getBaseURL().server_url + '/api/auth/login/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(res => res.json())
    .then(json => {
      if(!("error" in json)){
        authenticationService.isAuthenticated = true;
        localStorage.setItem('currentUser',JSON.stringify(
          json)
        );
        // console.log('login end');
        // console.log(authenticationService.getCurrentUser());
        return json;
      }
      else{
        return false
      }
    })
  );
}

function signup(data){
  // console.log('entra a Login');
  return(
    fetch(authenticationService.getBaseURL().server_url + '/api/auth/signup/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(res=> res.json())
    .then(json => {
      // console.log(json)
      if(!("error" in json)){
        return true;
      }
      else{
        return false;
      }
    })
  );
}

function validateUser(token){
  // console.log('entra a Login');
  return(
    fetch(authenticationService.getBaseURL().server_url + '/api/auth/validate_user/'+token, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    })
    .then(res=> res.json())
    .then(json => {
      // console.log(json)
      if(!("error" in json)){
        return true;
      }
      else{
        return false;
      }
    })
  );
}
function checkExistence(data){
  // console.log('entra a Login');
  return(
    fetch(authenticationService.getBaseURL().server_url + '/api/auth/check_existence/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    })
    .then(res=> res.json())
    .then(json => {
      return json
    })
  );
}

function passwordRecovery(data){
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };

  // console.log(options);
  return new Promise( (resolve, reject) => (
      fetch(authenticationService.getBaseURL().server_url + '/api/auth/password_recovery/',
      options)
      .then(res=> {
        let status = res.status;
        // let statusText = res.statusText;
        if([200,201,202,203,204,205,206,207,208,226].includes(status)){
          return resolve(res.json());
        }
        res.json().then(json => {
          return reject(json);
        })
      })
    )
  )
}

function logout(){
  localStorage.removeItem('currentUser');
  authenticationService.isAuthenticated = false;
  authenticationService.currentUser = null;
  return true;
}

function getBaseURL(){
  const hostname = window.location.hostname;
  let server_url = null;
  let client_url = null;

  if( ['0.0.0.0','127.0.0.1','127.0.1.1','localhost','127.0.0.0'].includes(hostname) ){
      server_url = "http://localhost:8000"
      client_url = "http://localhost:3000"
  }
  else{
      server_url = "https://permisosapi.renca.cl"
      client_url = "https://permisosweb.renca.cl"
  }
  const base_url = {
    server_url: server_url,
    client_url: client_url
  }
  return(base_url);
}
